import intl from 'react-intl-universal';
import { useState } from 'react';
// import { Space } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import styles from './index.less';
import SmsForm from './components/SmsForm';
import AccessButton from '@/components/AccessButton';

const Sms = () => {
    const [isShowModal, setIsShowModal] = useState(false);
    const [type, setType] = useState('');

    const smsClick = (type) => {
        setType(type);
        setIsShowModal(true);
    };
    return (
        <div className={styles.content}>
            <AccessButton
                isNeedLoad={false}
                className={styles.item}
                type="default"
                key="single"
                accessKey="sms-single"
                onClick={() => {
                    smsClick('single');
                }}
            >
                <MailOutlined className={styles.icon} />
                <div>{intl.get('短信')}</div>
            </AccessButton>
            <AccessButton
                isNeedLoad={false}
                className={styles.item}
                type="default"
                key="more"
                accessKey="sms-more"
                onClick={() => {
                    smsClick('more');
                }}
            >
                <MailOutlined className={styles.icon} />
                <div>{intl.get('批量短信')}</div>
            </AccessButton>
            <SmsForm
                open={isShowModal}
                type={type}
                title={
                    type === 'single'
                        ? intl.get('发送短信')
                        : intl.get('批量发送短信')
                }
                onCancel={() => setIsShowModal(false)}
            />
        </div>
    );
};

export default Sms;
